import { useState, useEffect, useRef, useCallback } from 'react';
import { Tab, OverlayTrigger, Tooltip, Accordion, Card } from 'react-bootstrap';
import BuildingColors from './BuildingColors/BuildingColors';
import BuildingSize from './BuildingSize/BuildingSize';
import Walls from './Walls/Walls';
import DoorWindow from './DoorWindow/DoorWindow';
import TaxDeposit from './TaxDeposit/TaxDeposit';
import ExtraOptions from './ExtraOptions/ExtraOptions';
import BuildingStyle from '../StateChange/BuildingStyle/BuildingStyle';
import Leantos from './Leantos/Leantos';
import ShowFullBuilding from "../BuildingCanvas/ShowFullBuilding";
import ExtraNotes from './ExtraNotes/Extranotes';
import AlertBox from '../Modals/AlertBox/AlertBox';
import PrintAlertBox from '../Modals/AlertBox/PrintAlertBox';
import { useDispatch, useSelector } from 'react-redux';
import { getSelectedTab, handleSidePanel, activeTabPanel, cameraFocusOnWall, buildingStyleChangeAccordingtoType, ShowHideTranslusant, handleActiveWallSubTab, selectCenterBuilding } from "../../action/index.js";
import { handleAccordionTab } from '../../action/building/building_style/buildingStyle.action.js';
import { handleShowExtras, updateOrderExtraItems } from "../../action/extra_options/orderExtras.action.js";
import SlideBottom from '../SlidePanels/SlideBottom.js';
import SlideHeader from '../Header/SlideHeader.js';
import AlertSize from '../Alert/AlertSize.js';
import FeedbackWrapper from '../SlidePanels/FeedbackWrapper.js';
import InformationTooltip from './Information/InformationTooltip.js';
import NewInsulation from './NewInsulation/NonLnT/NewInsulation.js';
import { capitalize, editCaseHeritage, getImage } from '../../redux/reducers/utils.js';
import { makeTranslucent } from '../../helpers/building/building_config/componentConfig.js';
import { heritageNoInsulation } from '../../helpers/insulation_pricing/insulationPricing.helper.js';
import LTShape from './LTShape/LTShape.jsx';
import { LEAN_TYPE_NUM_TO_STR } from '../../Constants/constant.js';
import RenderLean from './Leantos/RenderLean.js';
import Pdf from '../Pdf/Pdf.js';
import { const_var } from '../../redux/reducers/reducer.js';
import FileUpload from '../../Intel/component/fileUpload.js';


function isVisible(el) {
   if (!el) return false;
   const style = getComputedStyle(el);
   if (style.display === 'none') return false;
   if (style.visibility === 'hidden') return false;
   if (style.opacity === '0') return false;
   const rect = el.getBoundingClientRect();
   if (rect.width === 0 || rect.height === 0) return false;
   const inViewport = (
      rect.bottom > 0 &&
      rect.right > 0 &&
      rect.top < (window.innerHeight || document.documentElement.clientHeight) &&
      rect.left < (window.innerWidth || document.documentElement.clientWidth)
   );
   return inViewport;
}


const ComponentToPrint = () => <Pdf />;


const ControlPanel = () => {
   const dispatch = useDispatch();
   const const_var = useSelector(state => state.reducer.const_var);
   const params = useSelector(state => state.reducer.params);
   const selectedTabKey = useSelector(state => state.reducer.selectedTabKey);
   const selectedTabstate = useSelector(state => state.reducer.selectedTabstate);
   const isLTBuilding = useSelector(state => state.reducer.isLTBuilding);
   const selectedLeanType = useSelector(state => state.reducer.selectedLeanType);
   const isShowDiscountsPanel = useSelector(state => state.reducer.isShowDiscountsPanel);
   const alertUsedFor = useSelector(state => state.reducer.alertUsedFor);
   const controls = useSelector(state => state.eventReducer.controls);
   const isShowAlert = useSelector(state => state.quoteReducer.isShowAlert);

   const normalisedLeanType = selectedLeanType ?? "";

   const getScrollSectionHeight = useCallback(() => {
      return !isShowDiscountsPanel
         ? ((const_var.crmSetting.is_show_cta || const_var.crmSetting.is_show_cta === undefined) ? (window.innerHeight - 110) : (window.innerHeight - 72) + 'px')
         : ((const_var.crmSetting.is_show_cta || const_var.crmSetting.is_show_cta === undefined) ? (window.innerHeight - 158) : (window.innerHeight - 120) + 'px');
   }, [isShowDiscountsPanel, const_var.crmSetting.is_show_cta]);

   const [isInfoShow, setIsInfoShow] = useState(false);
   const [showModal, setShowModal] = useState(false);
   const [top, setTop] = useState(0);
   const [height, setHeight] = useState(0);
   const [scrollSectionHeight, setScrollSectionHeight] = useState(getScrollSectionHeight);

   const prevIsShowDiscountsPanelRef = useRef(isShowDiscountsPanel);

   const handleClose = () => setShowModal(false);
   const handleViewUpload = () => setShowModal(true);

   const changeHeight = useCallback(() => {
      setScrollSectionHeight(getScrollSectionHeight());
   }, [getScrollSectionHeight]);

   const handleInfoClose = useCallback(() => {
      if (document.getElementsByClassName("minimal-mode") && document.getElementsByClassName("minimal-mode").length !== 0)
         document.getElementsByClassName("minimal-mode")[0].style.display = '';
      if (document.getElementsByClassName("App") != undefined && document.getElementsByClassName("App").length > 0 && document.getElementsByClassName("App")[0].className.includes('activeInfoTooltip')) {
         document.getElementsByClassName("App")[0].classList.remove('activeInfoTooltip');
      }
      setIsInfoShow(false);
   }, []);

   const handleClickOutside = useCallback((event) => {
      const infoRef = document.getElementsByClassName('information-tooltip')[0];
      if (infoRef && !infoRef.contains(event.target)) {
         handleInfoClose();
      }
   }, [handleInfoClose]);

   const alignCenter = useCallback(() => {
      const tabs = document.querySelectorAll('.accordion-menu');
      for (let i = 0; i < tabs[0].children.length; i++) {
         const tab = tabs[0].children[i].children[0];
         tab.addEventListener('click', function (e) {
            if (e.target.className !== 'icon icon-info-ico') {
               setIsInfoShow(false);
            } else {
               return;
            }
            setTimeout(() => {
               const parent = document.querySelector('.scrollbar-plugin');
               const parentRect = document.querySelector('.scrollbar-plugin').getBoundingClientRect();
               const childRect = this.parentNode.getBoundingClientRect();
               const parentCenterY = parentRect.top + parentRect.height / 2;
               const childCenterY = childRect.top + childRect.height / 2;
               var newScrollTop = 0;
               if (parentRect.height < childRect.height) {
                  newScrollTop = parent.scrollTop + childRect.top - parentRect.top;
               } else {
                  newScrollTop = parent.scrollTop + (childCenterY - parentCenterY);
               }
               parent.scrollTo({ top: newScrollTop, behavior: 'smooth' });
            }, 500);
         });
      }
   }, []);

   useEffect(() => {
      alignCenter();
      changeHeight();
      window.addEventListener('resize', () => {
         changeHeight();
         handleInfoClose();
      });
      document.addEventListener('mousedown', handleClickOutside);
      return () => {
         document.removeEventListener('mousedown', handleClickOutside);
      };
   }, []);

   useEffect(() => {
      const panelclick = document.querySelectorAll('.build-option-tab .nav-item .nav-link');
      const body = document.querySelector('body');

      const handlePanelClick = () => body.classList.add("active-left-panel");
      panelclick.forEach((item) => {
         item.addEventListener('click', handlePanelClick);
      });

      function createRipple() {
         if (this.getElementsByClassName('ripple').length > 0) {
            this.removeChild(this.childNodes[1]);
         }
         const circle = document.createElement('div');
         this.appendChild(circle);
         circle.classList.add('ripple');
      }

      const buttons = document.querySelectorAll('.build-option-tab .nav-item');
      Array.prototype.forEach.call(buttons, function (b) {
         b.addEventListener('click', createRipple);
      });

      return () => {
         panelclick.forEach((item) => item.removeEventListener('click', handlePanelClick));
         Array.prototype.forEach.call(buttons, function (b) {
            b.removeEventListener('click', createRipple);
         });
      };
   }, []);

   useEffect(() => {
      if (prevIsShowDiscountsPanelRef.current !== isShowDiscountsPanel) {
         prevIsShowDiscountsPanelRef.current = isShowDiscountsPanel;
         changeHeight();
      }
   }, [isShowDiscountsPanel, changeHeight]);

   const tabSelect = (key) => {
      if (window.innerWidth <= 992) window.scrollTo(0, 0);
      dispatch(getSelectedTab(key));
      if (key == "notesextra") dispatch(handleShowExtras('notes'));
   };

   const handleInfoClick = (e) => {
      e.stopPropagation();
      if (window.innerWidth > 992) {
         var target = e.target.parentNode.parentNode.getBoundingClientRect();
         setTop(target.top);
         setHeight(window.innerHeight - target.top - 63);
      } else {
         const appRef = document.getElementsByClassName("App");
         appRef[0].classList.add("activeInfoTooltip");
         document.getElementsByClassName("minimal-mode")[0].style.display = 'none';
         setHeight('calc(100vh - 100px)');
      }
      setIsInfoShow(true);
   };

   const handleScroll = () => {
      if (isInfoShow) setIsInfoShow(false);
   };

   const checkFrom = () => {
      dispatch(updateOrderExtraItems());
   };

   const getBuildingName = (l) => {
      const buildingIndex = ['left', 'right', 'front', 'back']
         .filter(lean => params.leanStyle[lean] === 'gable')
         .findIndex(item => item === l);
      return `${capitalize(l)} (Building ${buildingIndex + 2})`;
   };

   const handleStateRendering = () => {
      makeTranslucent(controls.isCheckActiveTab, params.activeWall, params.is_translusant, const_var.scene);
      if (const_var.activeTab == "doorwindow" && controls.isCheckActiveTab != "doorwindow") { }
      if (const_var.activeTab == "leantos" && controls.isCheckActiveTab != "leantos") {
         if (params.singleSlope == true) {
            const_var.navEventKey.leanto = "rightLean";
         } else {
            if (
               (params.add_left_lean && const_var.navEventKey.leanto == "leftLean") ||
               (params.add_right_lean && const_var.navEventKey.leanto == "rightLean") ||
               (params.add_front_lean && const_var.navEventKey.leanto == "frontLean") ||
               (params.add_back_lean && const_var.navEventKey.leanto == "backLean")
            ) {
               const_var.navEventKey.leanto = const_var.navEventKey.leanto;
            } else if (params.add_left_lean) { const_var.navEventKey.leanto = "leftLean"; }
            else if (params.add_right_lean) { const_var.navEventKey.leanto = "rightLean"; }
            else if (params.add_front_lean) { const_var.navEventKey.leanto = "frontLean"; }
            else if (params.add_back_lean) { const_var.navEventKey.leanto = "backLean"; }
            else { const_var.navEventKey.leanto = "leftLean"; }
         }
      }
   };

   const onAccordionToggle = (e, eventKey, extraCb) => {
      dispatch(handleAccordionTab(e, eventKey));
      handleStateRendering();
      if (extraCb) extraCb();
      !const_var.isActiveSlide && dispatch(handleSidePanel(e, const_var.isActiveSlide));
   };

   if (const_var.loginSession == false) {
      if (selectedTabKey == 'extraoptions') document.querySelector("body").classList.add('extraoptionnonlogin');
      else document.querySelector("body").classList.remove('extraoptionnonlogin');
   }

   if (selectedTabKey == 'buildingtypetab') document.querySelector("body").classList.add('buildtypescreen');
   else document.querySelector("body").classList.remove('buildtypescreen');

   if (selectedTabstate == 'statechange' || selectedTabstate == 'loginstyletab') document.querySelector('body').classList.add('active-state-screen');
   else document.querySelector('body').classList.remove('active-state-screen');

   if (selectedTabKey == 'taxdeposit') {
      if (const_var.loginSession == true) document.querySelector("body").classList.add('paymentlogin');
      else document.querySelector("body").classList.remove('paymentlogin');
   } else {
      document.querySelector("body").classList.remove('paymentlogin');
   }

   const alertUsedKey = const_var.alertUsedFor;

   const directions = [];
   if (params.add_left_lean && params.leanStyle.left !== 'gable') directions.push("Left");
   if (params.add_right_lean && params.leanStyle.right !== 'gable') directions.push("Right");
   if (params.add_front_lean && params.leanStyle.front !== 'gable') directions.push("Front");
   if (params.add_back_lean && params.leanStyle.back !== 'gable') directions.push("Back");
   if (directions.length == 0) directions.push("None");
   const directionString = directions.join(", ");

   let allBuildingWalls = Object.values(const_var.checkWallClose).filter((value) => value != "utility");
   let currentWalls = [];
   let finalWallState = "";

   for (const wall of allBuildingWalls) {
      if (params.add_left_lean && wall.includes("p_b_c_b_l")) currentWalls.push(params[wall]);
      else if (params.add_right_lean && wall.includes("p_b_c_b_r")) currentWalls.push(params[wall]);
      else if (params.add_front_lean && wall.includes("p_b_c_b_f")) currentWalls.push(params[wall]);
      else if (params.add_back_lean && wall.includes("p_b_c_b_b")) currentWalls.push(params[wall]);
      else if (wall.includes("p_b_c_b") == false) currentWalls.push(params[wall]);
   }

   let openWall = currentWalls.filter((wallState) => wallState == "Open" && params.p_c_p_l == false && params.p_c_p_r == false);
   let closeWall = currentWalls.filter((wallState) => wallState == "Close");

   if (currentWalls.length == openWall.length) finalWallState = "Fully Opened";
   else if (currentWalls.length == closeWall.length) finalWallState = "Fully Enclosed";
   else finalWallState = "Custom";

   if (finalWallState == "Fully Opened" && params.endStoragePositionZ != undefined && params.endStoragePositionZ != 0) finalWallState = "Custom";
   if (finalWallState == "Fully Opened" && params.leftLeanStoragePosition != undefined && params.leftLeanStoragePosition != 0) finalWallState = "Custom";
   if (finalWallState == "Fully Opened" && params.rightLeanStoragePosition != undefined && params.rightLeanStoragePosition != 0) finalWallState = "Custom";
   if (finalWallState == "Fully Opened" && params.frontLeanStoragePosition != undefined && params.frontLeanStoragePosition != 0) finalWallState = "Custom";
   if (finalWallState == "Fully Opened" && params.backLeanStoragePosition != undefined && params.backLeanStoragePosition != 0) finalWallState = "Custom";

   let componentsCount = 0;
   if (isLTBuilding) {
      if (normalisedLeanType === '') componentsCount = const_var.newDoorsArray.filter(d => !d.userData.wallName.startsWith('G')).length;
      if (normalisedLeanType === 'left') componentsCount = const_var.newDoorsArray.filter(d => d.userData.wallName.startsWith('G_L')).length;
      if (normalisedLeanType === 'right') componentsCount = const_var.newDoorsArray.filter(d => d.userData.wallName.startsWith('G_R')).length;
      if (normalisedLeanType === 'front') componentsCount = const_var.newDoorsArray.filter(d => d.userData.wallName.startsWith('G_F')).length;
      if (normalisedLeanType === 'back') componentsCount = const_var.newDoorsArray.filter(d => d.userData.wallName.startsWith('G_B')).length;
   } else {
      componentsCount = const_var.newDoorsArray.length;
   }
   componentsCount = componentsCount + " Added";

   let isAdded = "Added";
   if (const_var.post_data != undefined && const_var.post_data.building != undefined) {
      let extraItems = JSON.parse(JSON.stringify(const_var.post_data?.building?.order_extra_items));
      delete extraItems["dont_show_processing_fee_pdf"];
      let extraItemskeys = Object.keys(extraItems);
      let addedItems = extraItemskeys.filter((items) => (parseInt(extraItems[items]) > 0 && extraItems[items] != "no" && extraItems[items] != "None" && extraItems[items] != ""));
      isAdded = addedItems.length > 0 ? "Added" : "None";
   }

   const finalWidth = params.p_w + (params.add_left_lean ? params.lean_p_w : 0) + (params.add_right_lean ? params.leanR_p_w : 0);
   const finalLength = params.p_d + (params.add_front_lean ? params.leanF_p_w : 0) + (params.add_back_lean ? params.leanB_p_w : 0);

   let editCheckForHeritage = editCaseHeritage();
   let heritageNoInsulationCase = heritageNoInsulation(params, editCheckForHeritage, false, "all");

   let insulationVal = 'None';
   if (params.p_c_i == true) insulationVal = 'Custom';
   if (params.p_r_o == true) insulationVal = 'Full Roof';
   if (params.p_f_i == true) insulationVal = 'Full Building';

   const topHeaderBanner = document.getElementsByClassName("top-header-banner");
   const discountsContainer = document.getElementsByClassName("discounts-container");
   const smallDevice = window.innerWidth < 992;
   let addBannerMargin = topHeaderBanner != undefined && topHeaderBanner?.length == 0 ? false : discountsContainer != undefined && discountsContainer?.length == 0 ? true : false;
   let collapseBannerCheck = document.getElementsByClassName('bottom-bnr-cta') != undefined && document.getElementsByClassName('bottom-bnr-cta')[0]?.innerHTML?.includes("%");
   let checkNone = document.getElementsByClassName("top-header-banner") != undefined && document.getElementsByClassName("top-header-banner")?.length > 0 && document.getElementsByClassName("top-header-banner")[0]?.className?.includes('d-none');
   let wallImg = getImage(params.wallTexture);

   return (
      <>
         <SlideHeader />
         <Tab.Container activeKey={selectedTabKey} onSelect={tabSelect}>
            <div className="build-tab-wrapper">
               <div className="right-panel-main-wrapper xwebkitScrollbar">
                  <div className="-top-wrapper">
                     <div className="building-total-price-sec d-none">
                        <ul>
                           <li className="today-deposit-top">
                              <aside className="mr-2">
                                 <span className="icon-total-deposite icon"></span>
                              </aside>
                              <aside>
                                 <p className="text-white barlow-semibold f-12 mb-1">Deposit ({const_var.downPersentage}%)</p>
                                 <p className="text-white barlow-semibold mb-0">
                                    ${(const_var.post_data.building != undefined) ? (const_var.post_data.building.order_total * const_var.downPersentage / 100).toFixed(2) : 0}
                                 </p>
                              </aside>
                           </li>
                           <li className="cursor-pointer show-price-summary">
                              <aside className="mr-2 d-none d-md-block">
                                 <span className="icon-total-price icon"></span>
                              </aside>
                              <aside className="no-line-height">
                                 <p className="text-white barlow-semibold f-12 mb-1 d-inline-flex align-items-center">
                                    Price & Summary
                                    {['bottom'].map(placement => (
                                       <OverlayTrigger key={placement} placement={placement} overlay={<Tooltip id={`tooltip-${placement}`}>Total Building Price & Summary</Tooltip>}>
                                          <a className="text-white pl-1 pt-1"><span className="icon-info"></span></a>
                                       </OverlayTrigger>
                                    ))}
                                 </p>
                                 <p className="text-white barlow-semibold mb-0">
                                    ${(const_var.post_data.building != undefined) ? const_var.post_data.building.order_total : 0}
                                 </p>
                              </aside>
                           </li>
                        </ul>
                     </div>

                     <AlertBox isShowAlert={isShowAlert} alertUsedFor={alertUsedFor} checkKey={alertUsedKey} />
                     <PrintAlertBox />

                     <div
                        className={
                           discountsContainer.length > 0
                              ? 'accordion-wrap'
                              : (smallDevice && addBannerMargin
                                 ? (collapseBannerCheck ? 'accordion-wrap mt-4' : (checkNone ? 'accordion-wrap' : 'accordion-wrap mt-5'))
                                 : 'accordion-wrap')
                        }
                        data-tut="configoptions"
                     >
                        <LTShape controls={controls} handleStateRendering={handleStateRendering} handleInfoClick={handleInfoClick} />

                        <div className='scrollbar-plugin' style={{ height: scrollSectionHeight }} onScroll={handleScroll}>
                           <Accordion activeKey={controls.isCheckActiveTab} className='accordion-menu'>

                              {/* Building Type */}
                              {!const_var.is_intel &&
                                 <AccordionCard
                                    eventKey="buildingtypetab"
                                    iconClass="icon-build-type-ico"
                                    label="Building Type"
                                    value={const_var.post_data?.building?.display_building_type_name}
                                    onToggle={(e) => onAccordionToggle(e, 'buildingtypetab')}
                                    onInfoClick={handleInfoClick}
                                 >
                                    <BuildingStyle />
                                 </AccordionCard>
                              }

                              {/* Built & Size — main building  (no lean selected) */}
                              <Card className={normalisedLeanType === "" ? 'card-menu' : 'card-menu d-none'}>
                                 <Accordion.Toggle as={Card.Header} eventKey="buildsizes" className='card-header-menu' onClick={(e) => onAccordionToggle(e, 'buildsizes')}>
                                    <span className='menu-icon'><i className='icon icon-built-size-ico'></i></span>
                                    <span className='menu-info' onClick={handleInfoClick}><i className='icon icon-info-ico'></i></span>
                                    <span className='menu-label'>Built & Size</span>
                                    <span className='menu-action'>
                                       <span className='menu-value'>Total - {`${finalWidth}'W x ${finalLength}'L x ${params.p_h}'H`}</span>
                                       <i className='icon icon-arrow-down-ico'></i>
                                    </span>
                                 </Accordion.Toggle>
                                 <Accordion.Collapse className='card-collapse-menu' eventKey="buildsizes">
                                    <Card.Body className='card-body-menu'><BuildingSize /></Card.Body>
                                 </Accordion.Collapse>
                              </Card>

                              {/* Built & Size when isLTBuilding is true.*/}
                              {['left', 'right', 'front', 'back'].map((leanType) =>
                                 isLTBuilding && (
                                    <LeanBuildingSize
                                       key={leanType}
                                       leanType={leanType}
                                       params={params}
                                       getBuildingName={getBuildingName}
                                       onInfoClick={handleInfoClick}
                                       isVisible={normalisedLeanType === leanType}
                                       onToggle={(e) => onAccordionToggle(e, `buildsizes_${leanType}`)}
                                    />
                                 )
                              )}

                              {/* Lean-To */}
                              {(isLTBuilding
                                 ? (normalisedLeanType === "" && (params.leanStyle.left != "gable" || params.leanStyle.right != "gable" || params.leanStyle.front != "gable" || params.leanStyle.back != "gable"))
                                 : true
                              ) &&
                                 <Card className='card-menu'>
                                    <Accordion.Toggle as={Card.Header} eventKey="leantos" className='card-header-menu' onClick={(e) => { setIsInfoShow(false); onAccordionToggle(e, 'leantos'); }}>
                                       <span className='menu-icon'><i className='icon icon-lean-to-ico'></i></span>
                                       <span className='menu-info' onClick={handleInfoClick}><i className='icon icon-info-ico'></i></span>
                                       <span className='menu-label'>Lean-To</span>
                                       <span className='menu-action'>
                                          <span className='menu-value'>{directionString}</span>
                                          <i className='icon icon-arrow-down-ico'></i>
                                       </span>
                                    </Accordion.Toggle>
                                    <Accordion.Collapse className='card-collapse-menu' eventKey="leantos">
                                       <Card.Body className='card-body-menu'><Leantos /></Card.Body>
                                    </Accordion.Collapse>
                                 </Card>
                              }

                              {/* Walls */}
                              <AccordionCard
                                 eventKey="walls"
                                 iconClass="icon-sides-ends-ico"
                                 label="Walls"
                                 value={finalWallState}
                                 onToggle={(e) => onAccordionToggle(e, 'walls', () => dispatch(handleActiveWallSubTab('center_building')))}
                                 onInfoClick={handleInfoClick}
                              >
                                 {controls.isCheckActiveTab == 'walls' && const_var.post_data?.building && <Walls />}
                              </AccordionCard>

                              {/* Doors & Windows */}
                              <AccordionCard
                                 eventKey="doorwindow"
                                 iconClass="icon-doors-window-ico"
                                 label="Doors & Windows"
                                 value={componentsCount}
                                 cardId="doorwindow_automation"
                                 onToggle={(e) => {
                                    if (params.is_translusant == true) dispatch(ShowHideTranslusant('full', "doorwindow"));
                                    onAccordionToggle(e, 'doorwindow');
                                 }}
                                 onInfoClick={handleInfoClick}
                              >
                                 <DoorWindow />
                              </AccordionCard>

                              {/* Colors */}
                              <AccordionCard
                                 eventKey="colors"
                                 iconClass="icon-color-ico"
                                 label="Colors"
                                 onToggle={(e) => onAccordionToggle(e, 'colors')}
                                 onInfoClick={handleInfoClick}
                                 customValue={
                                    <span className='menu-value'>
                                       <span className="color-switch-circle" style={{ background: params.p_r_c.replace("0x", "#") }}></span>
                                       {finalWallState != "Fully Opened"
                                          ? <span className="color-switch-circle" style={{ background: params.p_w_c.replace("0x", "#"), backgroundImage: `url(${process.env.REACT_APP_BASE_URL + wallImg})` }}></span>
                                          : null
                                       }
                                       <span className="color-switch-circle" style={{ background: params.p_t_c.replace("0x", "#") }}></span>
                                    </span>
                                 }
                              >
                                 {controls.isCheckActiveTab == 'colors' && <BuildingColors checkWall={finalWallState} />}
                              </AccordionCard>

                              {/* Insulation — fixed: was props?.controls?.isCheckActiveTab, now uses controls from selector */}
                              {const_var.insulationJson && const_var.insulationJson.length > 0 && !heritageNoInsulationCase &&
                                 <Card className={controls.isCheckActiveTab == 'insulation' ? 'card-menu active' : 'card-menu'}>
                                    <Accordion.Toggle as={Card.Header} eventKey="insulation" className='card-header-menu' onClick={(e) => onAccordionToggle(e, 'insulation')}>
                                       <span className='menu-icon'><i className='icon icon-insulation-ico'></i></span>
                                       <span className='menu-info' onClick={handleInfoClick}><i className='icon icon-info-ico'></i></span>
                                       <span className='menu-label'>Insulation</span>
                                       <span className='menu-action'>
                                          {(params.p_c_i == true || params.p_f_i == true || params.p_r_o == true) && <span className='menu-value'>{insulationVal}</span>}
                                          <i className='icon icon-arrow-down-ico'></i>
                                       </span>
                                    </Accordion.Toggle>
                                    <Accordion.Collapse className='card-collapse-menu' eventKey="insulation">
                                       <Card.Body className='card-body-menu'><NewInsulation /></Card.Body>
                                    </Accordion.Collapse>
                                 </Card>
                              }

                              {/* Options */}
                              <AccordionCard
                                 eventKey="options"
                                 iconClass="icon-option-ico"
                                 label="Options"
                                 value="Added"
                                 onToggle={(e) => onAccordionToggle(e, 'options')}
                                 onInfoClick={handleInfoClick}
                              >
                                 <ExtraOptions />
                              </AccordionCard>

                              {/* Notes & Extra / Payments — logged in, non-intel */}
                              {!const_var.is_intel && <>
                                 {const_var.loginSession == true &&
                                    <AccordionCard
                                       eventKey="notesextra"
                                       iconClass="icon-notes-ico"
                                       label="Notes & Extra"
                                       value={isAdded}
                                       onToggle={(e) => onAccordionToggle(e, 'notesextra', () => checkFrom())}
                                       onInfoClick={handleInfoClick}
                                    >
                                       <ExtraNotes />
                                    </AccordionCard>
                                 }
                                 {const_var.loginSession == true && const_var.crmSetting.is_quote_Edit != true &&
                                    <AccordionCard
                                       eventKey="taxdeposit"
                                       iconClass="icon-payment-ico"
                                       label="Payments"
                                       value={`Deposit $${const_var.post_data.building != undefined ? const_var.post_data.building.down_payment_total : 0}`}
                                       onToggle={(e) => onAccordionToggle(e, 'taxdeposit')}
                                       onInfoClick={handleInfoClick}
                                    >
                                       {controls.isCheckActiveTab == 'taxdeposit' && const_var.post_data && const_var.post_data.building && <TaxDeposit />}
                                    </AccordionCard>
                                 }
                              </>}

                              {/* Image Upload — intel only */}
                              {const_var.is_intel &&
                                 <Card className='card-menu'>
                                    <Accordion.Toggle
                                       as={Card.Header}
                                       eventKey="taxdeposit"
                                       className='card-header-menu'
                                       onClick={(e) => {
                                          dispatch(handleAccordionTab(e));
                                          handleViewUpload();
                                          handleStateRendering();
                                          !const_var.isActiveSlide && dispatch(handleSidePanel(e, const_var.isActiveSlide));
                                       }}
                                    >
                                       <span className='menu-icon'>
                                          <svg viewBox="0 0 24 24" width="22" height="22">
                                             <path d="M4 5h16v14H4z" fill="none" stroke="black" />
                                             <circle cx="8" cy="9" r="2" />
                                             <path d="M4 17l5-5 4 4 3-3 4 4" />
                                          </svg>
                                       </span>
                                       <span className='menu-label'>Image Upload</span>
                                       <span className='menu-action'></span>
                                    </Accordion.Toggle>
                                 </Card>
                              }

                           </Accordion>

                           <FeedbackWrapper />
                           {!const_var.is_intel && <SlideBottom />}
                        </div>
                     </div>
                  </div>

                  <div className="right-panel-bottom-wrapper temp-none" data-tut="leftpanelfooter">
                     <div className="d-none d-lg-block">
                        <ShowFullBuilding />
                     </div>
                  </div>
               </div>
            </div>
         </Tab.Container>

         {(controls.isCheckActiveTab == "buildsizes" || controls.isCheckActiveTab == "colors") &&
            <AlertSize props={controls.isCheckActiveTab} />
         }
         <FileUpload show={showModal} handleClose={handleClose} />
         <InformationTooltip activeTab={controls.isCheckActiveTab} show={isInfoShow} handleClose={handleInfoClose} top={top} height={height} />
      </>
   );
};


const AccordionCard = ({ eventKey, iconClass, label, value, customValue, onToggle, onInfoClick, children, cardId }) => (
   <Card className='card-menu'>
      <Accordion.Toggle as={Card.Header} eventKey={eventKey} id={cardId} className='card-header-menu' onClick={onToggle}>
         <span className='menu-icon'><i className={`icon ${iconClass}`}></i></span>
         <span className='menu-info' onClick={onInfoClick}><i className='icon icon-info-ico'></i></span>
         <span className='menu-label'>{label}</span>
         <span className='menu-action'>
            {customValue || (value != null && <span className='menu-value'>{value}</span>)}
            <i className='icon icon-arrow-down-ico'></i>
         </span>
      </Accordion.Toggle>
      <Accordion.Collapse className='card-collapse-menu' eventKey={eventKey}>
         <Card.Body className='card-body-menu'>{children}</Card.Body>
      </Accordion.Collapse>
   </Card>
);


const LEAN_SIZE_MAP = {
   left: (p) => `${p.lean_p_w}'W x ${p.lean_p_d}'L x ${p.lean_p_h}'H`,
   right: (p) => `${p.leanR_p_w}'W x ${p.leanR_p_d}'L x ${p.leanR_p_h}'H`,
   front: (p) => `${p.leanF_p_w}'W x ${p.leanF_p_d}'L x ${p.leanF_p_h}'H`,
   back: (p) => `${p.leanB_p_w}'W x ${p.leanB_p_d}'L x ${p.leanB_p_h}'H`,
};

const LeanBuildingSize = ({ leanType, params, getBuildingName, onInfoClick, onToggle, isVisible }) => (
   <Card className={isVisible ? 'card-menu' : 'card-menu d-none'}>
      <Accordion.Toggle as={Card.Header} eventKey={`buildsizes_${leanType}`} className='card-header-menu' onClick={onToggle}>
         <span className='menu-icon'><i className='icon icon-built-size-ico'></i></span>
         <span className='menu-info' onClick={onInfoClick}><i className='icon icon-info-ico'></i></span>
         <span className='menu-label'>Built & Size <span className='added-building-nm'>- {getBuildingName(leanType)}</span></span>
         <span className='menu-action'>
            <span className='menu-value'>Total - {LEAN_SIZE_MAP[leanType](params)}</span>
            <i className='icon icon-arrow-down-ico'></i>
         </span>
      </Accordion.Toggle>
      <Accordion.Collapse className='card-collapse-menu' eventKey={`buildsizes_${leanType}`}>
         <Card.Body className='card-body-menu'>
            <AddedBuildingSize leanType={leanType} />
         </Card.Body>
      </Accordion.Collapse>
   </Card>
);
export default ControlPanel;

const AddedBuildingSize = ({ leanType }) => {
   const leanto = useSelector((state) => state.reducer.const_var.post_data?.building?.leanto);
   let lean = leanto?.find((item) => LEAN_TYPE_NUM_TO_STR[item.leanto_type] === leanType);
   if (!lean) return null;
   return <RenderLean lean={lean} leanType={leanType} />;
};